import { useCallback, useState } from 'react';
import { debounce } from '../../../../../utils/commonFunctions';

export const useGeoenceSearch = ({ data, setRow, row }: any) => {
  const [searchValue, setSearchValue] = useState<string>('');

  const handleSearchFilter = useCallback(
    debounce((event: string) => {
      setSearchValue(event);
      const searchValue = event.toLowerCase();
      const activeRow = row?.find((item: any) => item.activeColor);
      const searchedDatas = data
        ?.map((value: any) => ({
          ...value,
          activeColor: activeRow?.geoZoneId === value?.geoZoneId ? true : false
        }))
        ?.filter((filterValue: any) => {
          const geofenceName = filterValue?.geofenceName?.toLowerCase();
          const geoType = filterValue?.geoType?.toLowerCase();
          return searchValue
            ? geofenceName.includes(searchValue) || geoType?.includes(searchValue)
            : true;
        });
      setRow(searchedDatas);
    }),
    [data, row]
  );
  return { handleSearchFilter, setSearchValue, searchValue };
};

export const useGeofenceSearchVehicle = ({ setViewEye, cardData }: any) => {
  const [searchVehicle, setSearchVehicle] = useState<any>(cardData?.vehicleNumber);

  const onClose = () => {
    setViewEye(false);
  };

  const handleSearchMappedVehicle = useCallback(
    debounce((event: string) => {
      const dataFilter = cardData?.vehicleNumber?.filter((value: any, index: number) =>
        value?.toLowerCase()?.includes(event?.toLowerCase())
      );
      setSearchVehicle(dataFilter || []);
    }),
    [cardData]
  );
  return { onClose, handleSearchMappedVehicle, searchVehicle };
};
